import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ReviewsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"reviews"}/>
}
